import { Privilege } from '../../privilege';

import { V1Group } from './group';
import { V1Repository } from './repository';
import { V1User } from './user';

type CommonPrivilege = {
  privilege: Privilege;
  repo: string;
  repository: V1Repository;
};

type UserPrivilege = CommonPrivilege & {
  user: V1User;
};

type GroupPrivilege = CommonPrivilege & {
  group: V1Group;
};

declare global {
  namespace BB {
    type V1UserPrivilege = UserPrivilege;
    type V1GroupPrivilege = GroupPrivilege;
  }
}

export type V1UserPrivilege = UserPrivilege;
export type V1GroupPrivilege = GroupPrivilege;
